module.exports = __webpack_public_path__ + "img/ani_jiant_t.d8592bad.png";